import React from 'react'

const ChatIcon = () => (
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5002 0.66091C10.4674 0.656988 8.47 1.19287 6.7122 2.21383C4.95441 3.23478 3.49924 4.70419 2.49541 6.47182C1.49158 8.23946 0.975152 10.2419 0.998826 12.2746C1.0225 14.3072 1.58545 16.2971 2.63017 18.0409L1.17015 23.4909L6.62016 22.0309C8.14128 22.9405 9.85203 23.4862 11.6189 23.6254C13.3857 23.7646 15.1609 23.4935 16.8056 22.8333C18.4504 22.1732 19.9204 21.1418 21.1007 19.8197C22.281 18.4976 23.1398 16.9206 23.61 15.2118C24.0802 13.5029 24.149 11.7086 23.8112 9.96877C23.4734 8.22895 22.738 6.59069 21.6625 5.18203C20.5869 3.77336 19.2003 2.63238 17.6109 1.8481C16.0216 1.06383 14.2725 0.657531 12.5002 0.66091Z" stroke="#163567" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.00018 9.66089H18.0002" stroke="#163567" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.00018 12.6609H18.0002" stroke="#163567" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.00018 15.6609H18.0002" stroke="#163567" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default ChatIcon



// WEBPACK FOOTER //
// ./src/components/assets/ChatIcon.js